export interface RestaurantMenu {
  Id: number;
  Restaurant: Restaurant;
  RestaurantId: number;
  Year: number;
  WeekNumber: number;
  Monday: string;
  Tuesday: string;
  Wednesday: string;
  Thursday: string;
  Friday: string;
  Saturday: string;
  Sunday: string;
  AllWeek: string;
}

export interface Restaurant {
  // Only used client side to destinguish a restaurant that matches with the users selected channels
  UserChannelMatched: boolean;
  Id: number;
  Name: string;
  Address: string;
  ChannelTermRestaurants: Array<ChannelTermRestaurant>;
}

export interface ChannelTermRestaurant {
  ChannelTermId: string;
  RestaurantId: number;
}

export class WeeklyRestaurantMenu {
  WeekNumber: number;
  WeekDay: string;
  menu: Array<MenuText>;
  constructor(opt?: Partial<WeeklyRestaurantMenu>) {
    Object.assign(this, opt);
  }
}

export class MenuText {
  value: string;
  constructor(opt?: Partial<MenuText>) {
    Object.assign(this, opt);
  }
}
